import React from "react";
import FlexBetween from "components/FlexBetween";
import { useTheme } from "@mui/material";
import deoviseTitleLogo from "assets/images/deovise_logo.png";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

function Navbar() {
  const { palette } = useTheme();
  const alt = palette.background.alt;
  const navigate = useNavigate();

  const mode = useSelector((state) => state.mode);

  return (
    <FlexBetween
      padding={"1rem 3rem"}
      backgroundColor={alt}
      marginBottom="1rem"
    >
      <img
        src={deoviseTitleLogo}
        alt="Deovise"
        onClick={() => navigate("/home")}
        style={{
          cursor: "pointer",
          height: "40px",
          width: "auto",
          filter: mode === "dark" ? "invert(1)" : "invert(0)",
        }}
      />
    </FlexBetween>
  );
}

export default Navbar;
